const ShipmentDeliveredIcon = ({ className }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="18" fill="#DCFCE7" />
      <path
        opacity="0.4"
        d="M11.3333 19.6663C11.3333 19.2061 11.7063 18.833 12.1666 18.833C12.6377 18.8346 13.1037 19.0863 13.4778 19.3482C14.1263 19.8022 14.9312 20.6372 15.8068 22.1696C16.0351 22.5692 15.8963 23.0782 15.4967 23.3065C15.0971 23.5349 14.5881 23.3961 14.3597 22.9965C13.5687 21.6122 12.9152 20.9888 12.522 20.7136C12.2805 20.5446 12.1383 20.5054 12.105 20.4974C11.6735 20.4659 11.3333 20.1059 11.3333 19.6663Z"
        fill="#2AAC5A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6147 13.1267C24.7748 13.5582 24.5548 14.0378 24.1233 14.1979C23.241 14.5252 22.2729 15.2067 21.2929 16.107C20.3223 16.9989 19.3869 18.0614 18.5662 19.0919C17.7472 20.1204 17.0527 21.1042 16.5627 21.8314C16.3002 22.221 16.0407 22.6135 15.7963 23.0148C15.5577 23.4082 15.0448 23.5344 14.6514 23.2958C14.2578 23.0571 14.1323 22.5447 14.3709 22.1511C14.4422 22.0352 14.5143 21.9197 14.5873 21.8049C14.7255 21.5876 14.9266 21.277 15.1805 20.9001C15.6877 20.1473 16.4087 19.1259 17.2624 18.0537C18.1146 16.9836 19.1094 15.8499 20.1653 14.8797C21.212 13.9181 22.3671 13.0718 23.5436 12.6353C23.9751 12.4752 24.4546 12.6952 24.6147 13.1267Z"
        fill="#2AAC5A"
      />
    </svg>
  );
};

export default ShipmentDeliveredIcon;
